const initialState = {
}

const misc = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state
  }
}

export default misc
